import {
  PortfolioIcon,
  RegisterIcon,
  RouteIcon,
  SearchIcon,
  SimulatorsHeaderIcon,
  FunnelIcon,
  SimulatorsIcon,
  ResearchManagementIcon,
  IconPrancheta,
  SearchUser,
  IconSalesManagement,
  LoadPositionIcon,
  SelfServiceIcon,
  IconReport,
  IconSalesForce,
  IconCreditCard,
  IconTools,
} from "~misc/icons";
import { Link, useParams } from "react-router-dom";
import useHeader from "./hooks/useHeader";
import useGlobalStore from "~hooks/useGlobalStore";
import { useEffect, useMemo, useState } from "react";
import { initialPath } from "~misc/paths";
import { Text } from "@chakra-ui/react";
import useUsuario from "~/fetchs/useUsuario";
import useVendedor from "~/fetchs/useVendedor";
import ModalResponse from "~components/Modal/ModalResponse";
import ModalAction from "~components/Modal/ModalAction";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";
import useParametros from "~fetchs/useParametros";
import useCliente from "~fetchs/useCliente";
import useSearchList from "~pages/Wallet/hooks/useSearchList";
import Select from '~components/Form/components/Select.jsx'
const HeaderMenu = () => {
  const { moduloName, setField } = useGlobalStore();
  const [modulo, setModulo] = useState("");
  const { path } = useHeader();
  const { parameter: id } = useParams();
  const [modalStatus, setModalStatus] = useState(true);
  const { getBotoesCliente, parametros } = useParametros();
  const { cliente } = useCliente(+id);



  useEffect(() => {
    if (location.pathname === '/' && import.meta.env.VITE_MODE === 'qa') {
      setModalStatus(true);
    } else {
      setModalStatus(false);
    }
  }, [location.pathname])

  const { usuario } = useUsuario();

  const {
    optionsVendedores,
    vendedorSelecionado,
    onChangeVendedor,
    modalSyncAlert,
    confirmVendedorChange,
    cancelVendedorChange
  } = useVendedor();

  const vendedoresOptions = useMemo(
    () => (Array.isArray(optionsVendedores) ? optionsVendedores : []),
    [optionsVendedores]
  );

  const visaoGeralOption = useMemo(
    () => vendedoresOptions.find(v => v.value === null) ?? { value: null, label: "VISÃO GERAL" },
    [vendedoresOptions]
  );

  const vendedorOptionsSemVisaoGeral = useMemo(
    () => vendedoresOptions.filter(v => v.value !== null),
    [vendedoresOptions]
  );

  const hasOnlyOwnSellerAndGeneralOption = useMemo(() => {
    if (vendedorOptionsSemVisaoGeral.length !== 1 || !usuario?.id) {
      return false;
    }

    return Number(vendedorOptionsSemVisaoGeral[0].value) === Number(usuario.id);
  }, [vendedorOptionsSemVisaoGeral, usuario?.id]);

  const vendedorPersistidoOption = useMemo(
    () => vendedorSelecionado
      ? vendedoresOptions.find(v => v.value === vendedorSelecionado) ?? visaoGeralOption
      : hasOnlyOwnSellerAndGeneralOption ? vendedorOptionsSemVisaoGeral[0] ?? visaoGeralOption : visaoGeralOption,
    [
      vendedorSelecionado,
      vendedoresOptions,
      hasOnlyOwnSellerAndGeneralOption,
      vendedorOptionsSemVisaoGeral,
      visaoGeralOption
    ]
  );

  const [selectedVendedorOption, setSelectedVendedorOption] = useState(vendedorPersistidoOption);

  useEffect(() => {
    if (!modalSyncAlert) {
      setSelectedVendedorOption(vendedorPersistidoOption);
    }
  }, [modalSyncAlert, vendedorPersistidoOption]);

  const handleChangeVendedor = (option) => {
    const nextOption = option ?? visaoGeralOption;
    setSelectedVendedorOption(nextOption);
    onChangeVendedor(nextOption);
  };

  useEffect(() => {
    if (path == `${initialPath}/carteira`) {
      setModulo("Carteira");
    } else if (path.startsWith(`${initialPath}/simuladores`)) {
      setModulo("Simuladores");
    } else if (path.startsWith(`${initialPath}/pesquisa-de-preco`)) {
      setModulo("Mapa da Mina");
    } else if (path.startsWith(`${initialPath}/funil-de-obras`)) {
      setModulo("Funil de Obras");
    } else if (path.startsWith(`${initialPath}/cadastro-e-credito`) || path.startsWith(`${initialPath}/carteira`)) {
      setModulo("Cadastro e Crédito");
    } else if (path.startsWith(`${initialPath}/tabela-preco`)) {
      setModulo("Tabela de Preços");
    } else if (path.startsWith(`${initialPath}/roteirizacao`)) {
      setModulo("Roteirização");
    }
    else if (path.startsWith(`${initialPath}/reflex/`)) {
      setModulo("Reflex");
    }
    else if (path.startsWith(`${initialPath}/gestao-de-pesquisa`)) {
      setModulo("Formulários");
    }

    else if (path.startsWith(`${initialPath}/gestao-de-vendas`)) {
      setModulo("Gestão de Vendas");
    }

    else {
      setModulo("");
    }
  }, [path]);

  useEffect(() => {
    setField("moduloName", modulo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modulo]);

  const {montaEndereco, renderTagContent } = useSearchList();

    const clientesVerify = useMemo(() => {

      if(cliente !== undefined && id !== undefined){
        return {
          ...cliente,
          endereco: cliente?.endereco ? montaEndereco(cliente.endereco) : "",
          tag: renderTagContent(cliente),
          roteirizacao: getBotoesCliente(cliente?.trilha?.nome, "roteirizacao"),
          simuladorEnsacados: getBotoesCliente(cliente?.trilha?.nome, "simulador de ensacados"),
          pesquisa: getBotoesCliente(cliente?.trilha?.nome, "pesquisa"),
          tabelaPreco: getBotoesCliente(cliente?.trilha?.nome, "tabela de preco"),
          formularios: getBotoesCliente(cliente?.trilha?.nome, "formularios"),
        };
      }

    }, [cliente, parametros]);

  const { checkin } = useCheckIn();

  const url = window.location.pathname;
  const match = url.match(/\/roteirizacao(?:\/consulta)?\/\d+/);
  const somenteReflex = usuario?.slugAcessos?.includes('acesso-somente-ao-menu-de-reflex');
  const shouldShowVendedorSelect =
    (usuario?.slugAcessos?.some(x => x == 'acessar-visao-de-coordenacao') || vendedoresOptions.length > 1) &&
    !hasOnlyOwnSellerAndGeneralOption &&
    !url.startsWith('/reflex') &&
    !url.startsWith(`${initialPath}/reflex`);

  return (
    <div className={`${path !== initialPath && "bg-[#F2F2F2]"}`}>
      <div className="container">
        {path == initialPath || path == "/" || path == '/links-uteis' || path == '/problemas-tecnicos' ? (
          <p className="text-center py-7 px-4">
            <span className="font-bold text-2xl">Bem-vindo ao VenD</span>
            <span className="text-secundaria font-bold text-2xl">+</span>
            <span className=" text-2xl"> selecione uma opção abaixo</span>
          </p>
        ) : (
          <div className="flex flex-col md:flex-row gap-y-5 justify-between items-center border-to-bottom py-4 px-2 lg:p-4 header-menu ">
            <Link
              to={
               modulo == "Tabela de Preços"
                  ? `${initialPath}/tabela-preco`
                  : modulo == "Cadastro e Crédito"
                    ? `${initialPath}/cadastro-e-credito`
                    : modulo == "Mapa da Mina"
                      ? `${initialPath}/pesquisa-de-preco/${id}`
                      : modulo === "Roteirização"
                        ? `${initialPath}/roteirizacao/mapa`
                        : modulo == "Funil de Obras"
                          ? `${initialPath}/funil-de-obras/proximas-negociacoes`
                          : modulo == "Formulários"
                            ? `${initialPath}/gestao-de-pesquisa`
                            : modulo == "Reflex"
                              ? `${initialPath}/reflex/mes-atual`
                              : modulo == "Gestão de Vendas"
                                ? `${initialPath}/gestao-de-vendas`
                                : `${initialPath}/${modulo.toLocaleLowerCase()}`
              }
              className="flex justify-between items-center gap-3"
            >
              <span className="svg-main">
                {modulo === "Carteira" && <PortfolioIcon />}
                {modulo === "Simuladores" && <SimulatorsHeaderIcon />}
                {modulo === "Funil de Obras" && <FunnelIcon />}
                {modulo === "Tabela de Preços" && <SimulatorsHeaderIcon />}
                {modulo === "Cadastro e Crédito" && <RegisterIcon />}
                {modulo === "Mapa da Mina" && <SearchIcon />}
                {modulo === "Roteirização" && <RouteIcon />}
                {modulo === "Formulários" && <IconPrancheta />}
                {modulo === "Reflex" && <SimulatorsHeaderIcon />}
                {modulo === "Gestão de Vendas" && <IconSalesManagement />}
              </span>
              <h3 className={`font-bold ${modulo === "Gestão de Vendas" ? "text-[10px]" : "text-lg"}`}>{moduloName} {import.meta.env.VITE_MODE === 'qa' ? '- Qualidade' : ''}</h3>
            </Link>
            { match ? (
                <div className="menu-items flex justify-around md:justify-between items-center gap-2">
                      {modulo != "Carteira" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-carteira') && (
                    <Link
                      to={`${initialPath}/carteira`}
                      className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                    >
                      <PortfolioIcon className="relative h-auto transition-all hover:w-11" />
                      <Text className="item-label">Carteira</Text>
                    </Link>
                  )}

                  {modulo != "Cadastro e Crédito" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-cadastro-de-clientes') && (
                    <Link
                      to={`${initialPath}/cadastro-e-credito`}
                      className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                    >
                      <RegisterIcon className="relative h-auto transition-all hover:w-11" />
                      <Text className="item-label">Cadastro e Crédito</Text>
                    </Link>
                  )}
                    {modulo != "Funil de Obras" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras') && (
                      <Link
                        to={ checkin ? `${initialPath}/funil-de-obras/${checkin.clienteId}/acompanhamento-mapeamento` : match ? `${initialPath}/funil-de-obras/${id}` :`${initialPath}/funil-de-obras/proximas-negociacoes`}
                        className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                      >
                        <FunnelIcon className="relative h-auto transition-all hover:w-11" />
                        <Text className="item-label">Funil de Obras</Text>
                      </Link>
                    )}

                  {clientesVerify?.tabelaPreco && modulo != "Tabela de Preços" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-tabela-de-precos') && (
                    <Link
                      to={ match ? `${initialPath}/tabela-preco/${id}` :`${initialPath}/tabela-preco`}
                      className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                    >
                      <SimulatorsIcon className="relative h-auto transition-all hover:w-11" />
                      <Text className="item-label">Tabela de Preços</Text>
                    </Link>
                  )}

              {clientesVerify?.simuladorEnsacados && modulo != "Simuladores" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-simuladores') && (
                <Link
                  to={ match ? `${initialPath}/simuladores/simulacoes/${id}` :`${initialPath}/simuladores`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                >
                  <SimulatorsHeaderIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Simuladores</Text>
                </Link>
              )}
               </div>
             ): modulo === "Gestão de Vendas" ? (
              <div className="menu-items flex justify-around md:justify-between items-center gap-2">

              {!url.includes('/gestao-de-vendas/posicao-de-carga') && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-posicao-de-carga') && (
                <Link
                  to={`${initialPath}/gestao-de-vendas/posicao-de-carga`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center "
                >
                  <LoadPositionIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !text-[10px]">Posição de Carga</Text>
                </Link>
              )}

              {!url.includes('/gestao-de-vendas/autosservico') && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-autosservico') && (
                <Link
                  to={`${initialPath}/gestao-de-vendas/autosservico`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center "
                >
                  <SelfServiceIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !text-[10px]">Autosserviço</Text>
                </Link>
              )}

              {!url.includes('/gestao-de-vendas/relatorio-de-vendas') && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-relatorio-de-vendas') && (
                <Link
                  to={`${initialPath}/gestao-de-vendas/relatorio-de-vendas/carteira`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center "
                >
                  <IconReport className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !text-[10px]">Relatório de Vendas</Text>
                </Link>
              )}

              {!url.includes('/gestao-de-vendas/sales-force') && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-sales-force') && (
                <Link
                  to={`${initialPath}/gestao-de-vendas/sales-force`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center "
                >
                  <IconSalesForce className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !text-[10px]">Eficiência de Vendas</Text>
                </Link>
              )}

              {!url.includes('/gestao-de-vendas/credito-de-clientes') && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-credito-de-clientes') && (
                <Link
                  to={`${initialPath}/gestao-de-vendas/credito-de-clientes`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center "
                >
                  <IconCreditCard className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !text-[10px]">Crédito de Clientes</Text>
                </Link>
              )}

              {!url.includes('/gestao-de-vendas/bateu-levou') && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-bateu-levou') && (
                <Link
                  to={`${initialPath}/gestao-de-vendas/bateu-levou`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center "
                >
                  <IconTools className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !text-[10px]">Ferramentas</Text>
                </Link>
              )}
              </div>
             ):(
              <div className="menu-items flex justify-around md:justify-between items-center gap-2">

             {!somenteReflex && modulo != "Roteirização" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-rota-do-dia') && (
                <Link to={`${initialPath}/roteirizacao/mapa`} className="item group flex-col rounded-full flex items-center justify-center">
                  <RouteIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Rotas</Text>
                </Link>
              )}

              {!somenteReflex && modulo === "Roteirização" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-gestao-de-pesquisas') && (
                <Link to={`${initialPath}/gestao-de-pesquisa`} className="item group flex-col rounded-full flex items-center justify-center">
                  <ResearchManagementIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label !w-20">Gestão de pesquisa</Text>
                </Link>
              )}

              {!somenteReflex && modulo != "Carteira" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-carteira') && (
                <Link
                  to={`${initialPath}/carteira`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                >
                  <PortfolioIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Carteira</Text>
                </Link>
              )}

              {!somenteReflex && modulo != "Cadastro e Crédito" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-cadastro-de-clientes') && (
                <Link
                  to={`${initialPath}/cadastro-e-credito`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                >
                  <RegisterIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Cadastro e Crédito</Text>
                </Link>
              )}

              {!somenteReflex && modulo != "Funil de Obras" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras') && (
                <Link
                  to={ checkin ? `${initialPath}/funil-de-obras/${checkin.clienteId}/acompanhamento-mapeamento` : match ? `${initialPath}/funil-de-obras/${id}` :`${initialPath}/funil-de-obras/proximas-negociacoes`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                >
                  <FunnelIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Funil de Obras</Text>
                </Link>
              )}

              {!somenteReflex && modulo != "Simuladores" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-simuladores') && (
                <Link
                  to={ match ? `${initialPath}/simuladores/simulacoes/${id}` :`${initialPath}/simuladores`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                >
                  <SimulatorsHeaderIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Simuladores</Text>
                </Link>
              )}

              {!somenteReflex && modulo != "Tabela de Preços" && usuario?.ativo && usuario?.slugAcessos?.includes('acesso-ao-menu-de-tabela-de-precos') && (
                <Link
                  to={ match ? `${initialPath}/tabela-preco/${id}` :`${initialPath}/tabela-preco`}
                  className="item group flex-col ml-3 rounded-full flex items-center justify-center"
                >
                  <SimulatorsIcon className="relative h-auto transition-all hover:w-11" />
                  <Text className="item-label">Tabela de Preços</Text>
                </Link>
              )}
            </div>
             )}
          </div>
        )}
        {window.location.origin === 'https://vendmais-qa.vcimentos.com' && (<>
          <ModalResponse
            isOpen={modalStatus}
            closeModal={(e) => {
              setModalStatus(false);
            }}
            status='alert'
            message='VOCÊ ESTÁ EM AMBIENTE DE TESTE'
            submessage='As informações desta página não serão refletidas para os clientes'
            button="Ok"
          />

        </>)}
      </div>

      {shouldShowVendedorSelect && (
        <div className="flex justify-center itens-center w-full py-3 bg-[#034EA2]">
            <Select
                noMargin={true}
                leftIcon={ <SearchUser className="h-5" />}
                className="w-4/5 lg:w-3/5 xl:w-1/2 max-w-[50em] !mb-0"
                placeholder="Selecione um vendedor da sua gestão"
                onChange={handleChangeVendedor}
                value={selectedVendedorOption}
                options={vendedoresOptions}
              />
        </div>
      )}

      {modalSyncAlert && usuario?.slugAcessos?.some(x => x == 'sincronismo-por-vendedor') && (
        <ModalAction
          isOpen={modalSyncAlert}
          onClose={cancelVendedorChange}
          title="Troca de vendedor detectada"
sub={<>Ao trocar o vendedor, é necessário sincronizar os dados novamente para garantir informações atualizadas. <br />Deseja iniciar a sincronização agora?</>}

          buttonOne="Ok"
          linkOne={confirmVendedorChange}
          buttonTwo="Cancelar"
          linkTwo={cancelVendedorChange}
        />
      )}
    </div>
  );
};

export default HeaderMenu;
